<template>
    <img 
        src="/img/urbanmums-logo-128.png" 
        srcset="/img/urbanmums-logo-128.png 1x, /img/urbanmums-logo-256.png 2x, /img/urbanmums-logo-384.png 3x, /img/urbanmums-logo-512.png 4x"
        alt="Urban Mums" />
</template>
